module.exports = __webpack_public_path__ + "static/media/Spotify_logo_with_text.8da2acf3.png";